import { SVGProps } from 'react';

interface CompressWideProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Compress/shrink icon (four inward-pointing corner arrows).
 * TODO: Move to @raydiant/raydial when ready.
 */
const CompressWide = ({ size = 16, ...props }: CompressWideProps) => {
  return (
    <svg
      width={size}
      height={(size * 12) / 16}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 0.75V4.25C5 4.6875 4.65625 5 4.25 5H0.75C0.3125 5 0 4.6875 0 4.25C0 3.84375 0.3125 3.5 0.75 3.5H3.5V0.75C3.5 0.34375 3.8125 0 4.25 0C4.65625 0 5 0.34375 5 0.75ZM0.75 7H4.25C4.65625 7 5 7.34375 5 7.75V11.25C5 11.6875 4.65625 12 4.25 12C3.8125 12 3.5 11.6875 3.5 11.25V8.5H0.75C0.3125 8.5 0 8.1875 0 7.75C0 7.34375 0.3125 7 0.75 7ZM12.5 0.75V3.5H15.25C15.6562 3.5 16 3.84375 16 4.25C16 4.6875 15.6562 5 15.25 5H11.75C11.3125 5 11 4.6875 11 4.25V0.75C11 0.34375 11.3125 0 11.75 0C12.1562 0 12.5 0.34375 12.5 0.75ZM11.75 7H15.25C15.6562 7 16 7.34375 16 7.75C16 8.1875 15.6562 8.5 15.25 8.5H12.5V11.25C12.5 11.6875 12.1562 12 11.75 12C11.3125 12 11 11.6875 11 11.25V7.75C11 7.34375 11.3125 7 11.75 7Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CompressWide;
